import ServicePage from "./ServicePage";

export default ServicePage;